import { styles } from 'consts';
import styled from 'styled-components';

const {
  fontMontserrat,
  paymentDescription,
  accordionTransition,
  boxShadow,
  selectedBoxShadow,
  greenSecondary,
  promoGradient,
} = styles;

interface IProps {
  isSelected: boolean;
  preSelected?: boolean;
  hasForm?: boolean;
  hasMethodPromotion?: boolean;
  isMobile?: boolean;
}

const promoGroupedWidth = '1.5rem';
const promoGroupedRightIndentValue = '.9rem';
const borderValue = '0.125rem';
const nestedBorderRadiusValue = '.4rem';

const setBoxShadow = (p: IProps) =>
  p.isSelected
    ? `0 .125rem .5rem 0 ${selectedBoxShadow}, 0 .125rem 1rem 0 ${selectedBoxShadow}`
    : `0 0.125rem 0.5rem 0 ${boxShadow}`;
const setPadding = ({ isSelected }: IProps) => (isSelected ? borderValue : 0);
const setPromoWidth = ({ hasMethodPromotion }: IProps) =>
  hasMethodPromotion ? `calc(100% - ${promoGroupedRightIndentValue})` : '100%';
const setBackgroundColor = ({ hasMethodPromotion }: IProps) =>
  hasMethodPromotion ? promoGradient : `linear-gradient(to top, ${greenSecondary}, ${greenSecondary})`;

export const CardWLGroupedContainer = styled.div`
  width: 90%;
  margin: 2rem auto 1rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin: 1.5rem auto;
  }
`;

export const CardWLGroupedContainerList = styled.div`
  height: auto;
`;

export const CardWLGroupedContentWrapper = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  width: ${setPromoWidth};
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background-image: ${setBackgroundColor};
  box-shadow: ${setBoxShadow};
  margin: 0.5rem 0 0.5rem;
  padding: ${setPadding};
  font-family: ${fontMontserrat};
  font-weight: 400;
  position: relative;
  z-index: 10;
`;

export const CardWLGroupedPromoElement = styled.div<IProps>`
  display: flex;
  top: 0;
  right: -${promoGroupedRightIndentValue};
  width: ${promoGroupedWidth};
  height: 100%;
  position: absolute;
  background: ${promoGradient} border-box;
  border-radius: 0 0.5rem 0.5rem 0;
  box-shadow: ${setBoxShadow};
  box-sizing: border-box;
  padding: 2px;
  z-index: -1;
  align-items: center;
  align-content: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 3px;
  }
`;

export const CardWLGroupedPromoElementText = styled.span`
  font-size: 0.575rem;
  color: #dddddd;
  font-family: ${fontMontserrat};
  font-weight: 600;
  @supports (writing-mode: sideways-lr) {
    padding-left: 0.5rem;
    display: flex;
    writing-mode: sideways-lr;
    transform: none;
    justify-content: space-evenly;
    align-content: center;
    align-items: flex-end;
  }
  @supports not (writing-mode: sideways-lr) {
    padding-top: 0.5rem;
    display: inline-block;
    white-space: nowrap;
    transform: rotate(-90deg);
    transform-origin: center;
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
  }
`;

export const CardWLGroupedItemDescription = styled.div`
  color: ${paymentDescription};
  height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  margin-right: 4.25rem;

  @media (min-width: 768px) and (max-width: 940px), (max-width: 450px) {
    padding-top: 0.3rem;
    line-height: 1.3;
    height: 1.5rem;
  }

  @media (max-width: 768px) {
    margin-right: 0.25rem;
  }
`;

export const CardWLGroupedWidgetContainer = styled.div`
  display: flex;
  transition: ${accordionTransition};
  background-color: #fff;
  border-radius: 0 0 ${nestedBorderRadiusValue} ${nestedBorderRadiusValue};
  height: auto;
  width: 100%;
  flex-direction: row;
  #card-component__wl-main {
    margin-top: 0.8rem !important;
    margin-bottom: 0.8rem !important;
  }
  .card-component__wl-container {
    margin-top: 0 !important;
    margin-bottom: 5rem !important;
  }
`;
